export const APP_PREFIX = '/path-finder';
export const ORGANIZATION_PAYMENTS_SUFFIX = 'payments';
export const USER_ORG_PAYMENT_TABLE_URL = `${APP_PREFIX}/users/:userId/main/:orgId/${ORGANIZATION_PAYMENTS_SUFFIX}`;
export const USER_MAIN_PAGE_URL = `${APP_PREFIX}/users/:userId/:tab/:orgId?`;
export const PAYMENT_VIEW_URL = `${USER_ORG_PAYMENT_TABLE_URL}/:paymentId`;
export const POSTMARK_BASE_URL =
  'https://account.postmarkapp.com/servers/3687468/streams/outbound/events';
